export class Bank {
	public id?: number;
	public compensationParticipation?: boolean;
	public ispbCode?: number;
	public popular?: boolean;
	public label?: string;
	public name?: string;
	public code?: number;

	constructor() { }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/models/banks.ts